import format from 'date-fns/format'
import locales from '../locales'

const formatDate = (date, token, language) => {
  return format(date, token, { locale: locales[language] })
}

export const createLittleCalendarFormatter = language => start => {
  const startDate = new Date(start)
  return {
    header: formatDate(startDate, 'LLL', language),
    body: formatDate(startDate, 'd', language),
  }
}
